/*
  ============================================================================
  TYNA — Pix e parcelamento no CARRINHO (Sacola + quick cart do "+")
  ============================================================================

  Exibe, sob o subtotal, duas linhas calculadas sobre o valor dos PRODUTOS:

      SUBTOTAL        R$ 329,00
      Pix             R$ 312,55 (5% desconto)
      Crédito         2x de R$ 164,50 (sem juros)

  Os parâmetros comerciais (percentual do Pix, máximo de parcelas e parcela
  mínima) NÃO estão escritos aqui. Eles vêm de snippets/tyna-price.liquid,
  emitidos no <head> por layout/theme.liquid como:

      {%- render 'tyna-price', style: 'params-json' -%}

  Sem esse JSON, este arquivo não faz nada — de propósito. É melhor não exibir
  nada do que exibir número inventado.

  A matemática abaixo é a MESMA do tyna-price.liquid, inclusive nos
  arredondamentos (Pix trunca, parcela arredonda para cima). Se divergir, o
  cliente vê um valor na vitrine e outro no carrinho.

  Atenção: o desconto Pix incide sobre os produtos, não sobre o frete.
  ============================================================================
*/
(function () {
  'use strict';

  // --- Parâmetros -----------------------------------------------------------
  var P = null;
  try {
    var paramsEl = document.getElementById('tyna-price-params');
    if (paramsEl) P = JSON.parse(paramsEl.textContent);
  } catch (e) {
    P = null;
  }
  if (!P || typeof P.pix_percent !== 'number' || typeof P.max_installments !== 'number') return;

  var PIX_PERCENT = P.pix_percent;
  var MAX_INSTALLMENTS = P.max_installments;
  var MIN_INSTALLMENT_CENTS = P.min_installment_cents;

  // --- Formatação -----------------------------------------------------------
  // Espelha "R$ {{amount_with_comma_separator}}" do money_format da loja.
  function brl(cents) {
    var parts = (Math.round(cents) / 100).toFixed(2).split('.');
    var int = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return 'R$ ' + int + ',' + parts[1];
  }

  // --- Matemática (idêntica ao tyna-price.liquid) ---------------------------
  // Pix: aritmética inteira sobre centavos. O Liquid faz divisão inteira, que
  // trunca — Math.floor reproduz isso exatamente.
  function pixCents(base) {
    return Math.floor((base * (100 - PIX_PERCENT)) / 100);
  }

  // Maior número de parcelas (até o máximo) que respeite a parcela mínima.
  // A comparação usa a divisão truncada, como no Liquid.
  function plan(base) {
    var n = 1;
    for (var i = 2; i <= MAX_INSTALLMENTS; i++) {
      if (Math.floor(base / i) >= MIN_INSTALLMENT_CENTS) n = i;
    }
    // Parcela arredondada PARA CIMA: N x parcela nunca fica abaixo do total.
    return { n: n, parcel: Math.ceil(base / n) };
  }

  function rows(base, withSubtotal) {
    var p = plan(base);
    var html = '';
    if (withSubtotal) {
      html +=
        '<div class="tyna-pay__row tyna-pay__row--subtotal">' +
        '<span>SUBTOTAL</span><span>' + brl(base) + '</span></div>';
    }
    html +=
      '<div class="tyna-pay__row"><span>Pix</span><span>' +
      brl(pixCents(base)) +
      ' <em>(' + PIX_PERCENT + '% desconto)</em></span></div>';
    html +=
      '<div class="tyna-pay__row"><span>Crédito</span><span>' +
      p.n + 'x de ' + brl(p.parcel) +
      ' <em>(sem juros)</em></span></div>';
    return html;
  }

  function intAttr(el, name) {
    if (!el) return 0;
    var v = parseInt(el.getAttribute(name), 10);
    return isNaN(v) ? 0 : v;
  }

  // --- Sacola (cart-drawer) -------------------------------------------------
  // Âncora: .cart-drawer__summary-total, que contém
  // [data-cart-total-price] em CENTAVOS. O bloco entra logo abaixo dela.
  function applyCart() {
    var totals = document.querySelectorAll('.cart-drawer__summary-total');
    for (var i = 0; i < totals.length; i++) {
      var total = totals[i];
      var base = intAttr(total.querySelector('[data-cart-total-price]'), 'data-cart-total-price');

      var box = total.nextElementSibling;
      if (box && box.className.indexOf('tyna-pay') !== 0) box = null;

      if (base <= 0) {
        if (box && box.parentNode) box.parentNode.removeChild(box);
        continue;
      }

      if (!box) {
        box = document.createElement('div');
        box.className = 'tyna-pay';
        total.parentNode.insertBefore(box, total.nextSibling);
      }

      var sig = 'c' + base;
      if (box.getAttribute('data-tyna-sig') === sig) continue;
      box.setAttribute('data-tyna-sig', sig);
      box.innerHTML = rows(base, false);
    }
  }

  // --- Quick cart do "+" ----------------------------------------------------
  // Aqui NÃO existe subtotal: o produto ainda não está no carrinho. A base é
  // o preço da variante × quantidade, lido de [data-price] (centavos).
  // O bloco padrão de preço (.custom-price-details) é ocultado por CSS via a
  // classe .tyna-pay-on — aplicada por JS, para que sem JS nada suma.
  function applyQuick() {
    var roots = document.querySelectorAll('.quick-cart-product');
    for (var i = 0; i < roots.length; i++) {
      var root = roots[i];
      var container = root.querySelector('[data-price]');
      if (!container) continue;

      var unit = intAttr(container, 'data-price');
      if (unit <= 0) continue;

      var qtyEl = root.querySelector('[name="quantity"]');
      var qty = qtyEl ? parseInt(qtyEl.value, 10) : 1;
      if (!(qty > 0)) qty = 1;

      var base = unit * qty;

      var box = container.querySelector('.tyna-pay');
      if (!box) {
        box = document.createElement('div');
        box.className = 'tyna-pay tyna-pay--quick';
        container.appendChild(box);
      }
      container.classList.add('tyna-pay-on');

      var sig = 'q' + base;
      if (box.getAttribute('data-tyna-sig') === sig) continue;
      box.setAttribute('data-tyna-sig', sig);
      box.innerHTML = rows(base, true);
    }
  }

  // --- Re-render ------------------------------------------------------------
  // As duas gavetas são reconstruídas por innerHTML (cart.js renderContents e
  // quick-cart-drawer.js), e o quick cart é reescrito de novo a cada troca de
  // variante por ProductCard.updatePriceForVariant. Por isso o observer:
  // qualquer caminho que reconstrua o DOM cai aqui de volta.
  var scheduled = false;
  var busy = false;

  function run() {
    busy = true;
    try {
      applyCart();
      applyQuick();
    } catch (e) {
      /* nunca derruba a gaveta por causa desta linha */
    }
    busy = false;
    scheduled = false;
  }

  function schedule() {
    if (scheduled || busy) return;
    scheduled = true;
    (window.requestAnimationFrame || window.setTimeout)(run, 0);
  }

  function start() {
    run();
    if (window.MutationObserver) {
      new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    }
    // Troca de variante e de quantidade não mudam o DOM em todos os caminhos.
    document.addEventListener('change', schedule, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
